export default class DeleteOfferModal {
  constructor(args) {
    this.modal = args.modal;

    if(!this.modal.element) return;

    this.buttonShowModal = document.querySelectorAll('.button-show-delete-modal');
    this.buttonConfirm = this.modal.element.querySelector('.button-confirm');
    this.buttonCancel = this.modal.element.querySelector('.button-cancel');
    this.deleteUrl = this.modal.element.getAttribute('data-delete-url');

    this.addEvents();
  }

  addEvents() {
    [...this.buttonShowModal].map(button => {
      button.addEventListener('click', e => this.modal.open());
    });

    this.buttonConfirm.addEventListener('click', e => {
      location.href = this.deleteUrl;
    });

    this.buttonCancel.addEventListener('click', e => {
      this.modal.close();
    });
  }
}